import React, { useState, useEffect,useRef} from 'react';
 
import DatePicker from 'react-datepicker'; 
import Layout from './Layout';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar  } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Helper from './Helper';
import VirtualizedSelect from 'react-virtualized-select';
import axios, { AxiosError } from 'axios';
import { apiUrl } from './UrlParam';
import { apiUrl2 } from './UrlParam';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import api from './AxiosFetchData';
import apiEx from './SetURL';
import { useParams , useNavigate} from 'react-router-dom';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import ConfirmationButton from '../components/ConfirmationButton'  ;
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AxiosFetchData from './AxiosFetchData';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
 import CustomDialog from '../components/Dialog'

const MaterialDetail = () => {
   
    
    const [message,setmessage] = useState('');
    const [selectedOptionPayment, setSelectedOptionPayment] = useState(null);
    const [selectedOptionPoType, setSelectedOptionPoType] = useState(null);
    const [paymentOption, setPaymentOption] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [rows, setRows] =  useState([]);
    const [revRows, setRevRows] =  useState([]);
    const [unitList, setUnitList] = useState([]);
    const [selectedOptionUnit, setSelectedOptionUnit] = useState(null);
    const [qty, setQty] =  useState(0);
    const [hpp, setHpp] =  useState(0);
    const [totalHpp, setTotalHpp] =  useState(0);
    const [totalHpp2, setTotalHpp2] =  useState(0);
    const [price, setPrice] =  useState(0);
    const [totalPrice, setTotalPrice] =  useState(0);
    const [partNo, setPartNo] =  useState('');
    const [descriptions, setDescription] =  useState('');
    const [poId, setPoId] =  useState('');
    const [typeServiceList, setTypeServiceList] =  useState('');
    const [selectedTypeService, setselectedTypeService] =  useState('');
    const [productRows, setProductRows] = useState([]);
    const [product, setProduct] = useState({});
    const [randomId, setRandomId] =  useState('');
    const [customer, setCustomer] =  useState('');
    const [contactPerson, setContactPerson] =  useState('');
    const Navigate = useNavigate();
    const { id } = useParams();
    const { id2 } = useParams();
    const [disc, setDisc] =  useState(0);
    const [discValue, setDiscValue] =  useState(0);
    const [ppn, setPpn] =  useState(0);
    const [pph, setPph] =  useState(0);
    const [comm, setComm] =  useState(0);
    const [total, setTotal] =  useState(0);
    const [totalPpn, setTotalPpn] =  useState(0);
    const [totalPph, setTotalPph] =  useState(0);
    const [grandTotal, setGrandTotal] =  useState(0);
    const [totalDisc, setTotalDisc] =  useState(0);
    const [commValue, setCommValue] =  useState(0);
    const [productId, setProductId] =  useState('');
    const [subject, setSubject] =  useState('');
    const [notes, setNotes] =  useState('');
    const [contactId, setContactId] =  useState('');
    const [customerId, setCustomerId] =  useState('');
    const [product_id, setProduct_id] = useState({});
    const [poCode, setPoCode] =  useState('');
    const [type, setType] =  useState(0);
    const [rev, setRev] =  useState(0);
    const [revTemp, setRevtemp] =  useState(0);
    const [revDefault, setRevDefault] =  useState(0);
    const [anchorEl, setAnchorEl] = React.useState(null);
    
    const [reqNo, setReqNo] =  useState('');
    const menuOpen = Boolean(anchorEl);
    const handleClick = (event,data) => {
      //alert(id)
      //setSelectedData(data)
      setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('ReturnUrl');
  
    
    useEffect(() => {
        GetData();
       
      }, []);

      async function GetRev(){
        try{
            var response = await api.get(`GetRev/${id2}`).refreshToken(Navigate);
            if(response.data){
                const rowsWithRowNumbers = response.data.map((row, index) => ({
                    ...row,
                    rowNumber: index + 1,
                   
                }));
                setRevRows(rowsWithRowNumbers)
            }
        }catch(e){
            setmessage(e.message)
        }
       
      }

     async function GetData(){
        try{
          var data = [
            {
              "rmid": id2
            }
          ]
          var response = await axios.post(`${apiUrl2}/api/getRequestMaterialManagementById`, data);
          if(response){
                var rowsWithRowNumbers;
                 if(response.data.length > 0){
                      rowsWithRowNumbers = response.data[0].items.map((row, index) => ({
                      ...row,
                      rowNumber: index + 1,
                    }));
                 }
               
               
               if(id2 != 0){
                setContactPerson(response.data[0].req_no)
                setReqNo(response.data[0].req_no)
                setPoDate(new Date(response.data[0].req_date))
                setValidUntil(new Date(response.data[0].req_date_ready))
                setProductRows(rowsWithRowNumbers)
                 
               }
          }
        }catch(e){
            setmessage(e.message)
        }
    }

    const handleClickOpen = async () => {
        var response; 
        try{
            setProductId('')
            setQty(0);
            setTotalHpp(0);
            setTotalPrice(0);
            setPrice(0)
            setHpp(0)
            setSelectedOptionUnit(null);
            setPartNo('')
            setDescription('')
            setselectedTypeService(null)
            setOpen(true);
 
            response =  await axios.get(`${apiUrl2}/api/GetProduct`);
            
            if(response)
            {
                const rowsWithRowNumbers = response.data.map((row, index) => ({
                    ...row,
                    rowNumber: index + 1, 
                    qty : 0
                    }));
                setRows(rowsWithRowNumbers);
            }
        }catch(e){ 
           setmessage(e.message);
        }
    };
  
    const handleClose = () => {
      setOpen(false);
    };
 

    const [validUntil,setValidUntil] = useState(new Date());
    const [poDate,setPoDate] = useState(new Date());


    function GetPaymentTerm(){
        axios.get(`${apiUrl}/api/GetPaymentTerm`)
        .then((response) => {
          const transformedOptions = response.data.map((item) => ({
            label: `${item.id} - ${item.name}`,
            value: item.id,
          }));
          setPaymentOption(transformedOptions);
          //return transformedOptions;
        })
        .catch((error) => {
          console.error('Error fetching category data:', error);
        });
         
    }
  
    async function handleDefault(){
        try{
            const response = await api.get(`SetDefault/${id2}`).refreshToken(Navigate);
            if(response){
                
                setmessage(response.data);
                await GetRev();
                setAnchorEl(null)
            }
        }catch(err){
            setmessage(err.message);
        }
        
    }

    function handleDelete(id){
        
        const rowsWithRowNumbers = productRows.filter((row) => row.product_id !== id).map((row, index) => ({
            ...row,
            rowNumber: index + 1,
           
        }));

       setProductRows(rowsWithRowNumbers)
      // handleTotal(rowsWithRowNumbers);
    }
 

    const handleMainQtyChange = (value,id) => {
      let newList = Array.from(productRows);
      let objToUpdate = newList.find((el) =>  el.product_id == id) // grab first element with matching id
      objToUpdate.qty = value;
      setProductRows(newList);
    }


    const handleQtyChange = (value,id) => {
      let newList = Array.from(rows);
      let objToUpdate = newList.find((el) =>  el.product_id == id) // grab first element with matching id
      objToUpdate.qty = value;
      setRows(newList);
    }

    const handleAddProduct=(data) =>{

      var newData = [...productRows.filter((row) => row.product_id !== data.product_id).map((row) => ({
        ...row,
        rdid : 0
      }))]
      
       var list = [...newData, data].map((row, index) => ({
        ...row,
        rowNumber: index + 1, 
      
        }));

      setProductRows(list)
      handleClose()
    }
      
      const productColumns= [
        { field: 'rowNumber', headerName: 'No.', width: 70 },
        {
            field: 'actions',
            headerName: '',
            width: 150,
            renderCell: (params) => (
              <>
              {type == 0 && (
                 <Button
                   onClick={() => handleDelete(params.row.product_id)} // Pass the project ID to the edit function
                //  className="btn btn-primary mr-2"
                 >
                  <DeleteForeverIcon  sx={{ fontSize: 20 }}/>
                </Button>
              )}

              
              </>
              
            ),
        },
        { field: 'product_code', headerName: 'Code.', width: 200 },
        { field: 'product_name', headerName: 'Name', width: 250 },
        { field: 'units_name', headerName: 'Unit', width: 50 },
        // { field: 'qty', headerName: 'Qty', width: 100 },
        {
          field: 'Qty',
          headerName: 'Qty',
          width: 100,
         
          renderCell: (params) => (
            <>
             <input
                type="number"
                 className="form-control"
                value={params.row.qty}
                onChange={(e) => handleMainQtyChange(e.target.value, params.row.product_id)}
              /> 
            </>
          ),
      },
        { field: 'end_stock', headerName: 'Stock', width: 100 },
        
      ];

      const columns= [
        { field: 'rowNumber', headerName: 'No.', width: 50 },
        // { field: 'id', headerName: 'ID.', width: 250, hideable: false},
        { field: 'product_code', headerName: 'Code.', width: 250 },
        { field: 'product_name', headerName: 'Name', width: 250 },
        { field: 'units_name', headerName: 'Unit', width: 50 },
        { field: 'end_stock', headerName: 'Stock', width: 80 },
        {
          field: 'Qty',
          headerName: 'Qty',
          width: 100,
         
          renderCell: (params) => (
            <>
             <input
                type="number"
                 className="form-control"
                value={params.row.qty}
                onChange={(e) => handleQtyChange(e.target.value, params.row.product_id)}
              /> 


            </>
            
          ),
      },
      {
        field: 'add',
        headerName: '',
        width: 100,
       
        renderCell: (params) => (
          <>
           <button type='button' className='btn btn-info' onClick={(e) => handleAddProduct(params.row)} >ADD</button>
          </>
          
        ),
    },
      ];

       

      const handleRowClick = (
        params, // GridRowParams
        event, // MuiEvent<React.MouseEvent<HTMLElement>>
        details, // GridCallbackDetails
      ) => {
      // console.log(params)
      // alert(params.row.id)
       setHpp(params.row.hpp)
       setPrice(params.row.price)
       setSelectedOptionUnit({value : params.row.unit_id, label : params.row.unit_id + ' - ' + params.row.units_name})
    //    setTotalHpp(params.row.hpp * qty)
    //   setTotalPrice(params.row.price * qty)
       setTotalHpp(params.row.hpp * (event == undefined ? params.row.qty : qty))
       setTotalPrice(params.row.price * (event == undefined ? params.row.qty : qty))
       setPartNo(params.row.part_no)
       setDescription(params.row.descriptions)
       setPoId(id)
       setselectedTypeService(params.row.product_type)
       setDescription(params.row.descriptions)
       setRandomId(params.row.id)
       setselectedTypeService(params.row.product_type)
       setProduct_id(params.row.product_id)
      };

      const handleQty = (value)=>{
       // alert(value)
         setQty(value)
         setTotalHpp(value * hpp);
         setTotalPrice(value * price)
      }

      
      const handleSave = async (e) => {
         e.preventDefault(); 
         try{
          //  console.log(selectedOptionPoType)
            var data = {
                project_id : id,
                req_date : poDate,
                req_date_ready : validUntil,
                items : productRows.map((row, index) => ({
                    product_id : row.product_id,
                    product_stock_id: row.product_stock_id,
                    qty : row.qty,
                    hpp: row.last_buy_price ?? row.hpp,
                }))
            }
            
           // const response = await api.post(`UpdatePO?id=${id2}`, data).refreshToken(Navigate);
           if(reqNo){
              data.rmid = id2
              data.items =  productRows.map((row, index) => ({
                req_id : parseInt(id2),
                product_id : row.product_id,
                product_stock_id: row.product_stock_id,
                qty : parseInt(row.qty),
                hpp: row.last_buy_price ?? parseInt(row.hpp),
            }))
            //console.log(data)
              await axios.post(`${apiUrl2}/api/EditRequestMaterialManagement`, data);
              setmessage("Data Susccesfully Updated")
           }else{
              await axios.post(`${apiUrl2}/api/registerRequestMaterialManagement`, data);
              setmessage("Data Susccesfully Added")
           }
            
         }catch(err){
           //alert(err.message)
            setmessage(err.message);
         }
      }

      const handleRev = async (type) => {
            const response = await AxiosFetchData.get(`GetLastRev/${id}/${id2}`).refreshToken(Navigate);
            
            if(response){
                if(type=='add'){
                    setRev(parseInt(response.data) + 1)
                }else{
                    setRev(revTemp)
                }
                
                setAnchorEl(null);
            }
            
      }

      async function handleDeleteRev(id, revDefault){
        try{
            const response = await api.delete(`DeleteRev/${id}/${revDefault}`).refreshToken(Navigate)
            if(response){
                setmessage(response.data.msg)
                if(response.data.value == 0){
                    await GetRev();
                    return;
                }

                setTimeout(() => {
                    Navigate(`/AddPO/${id}/${response.data.value}?ReturnUrl=${myParam}`)
                }, 300);
                
            }
        }catch(err){
            setmessage(err.message)
        }
            
      }

    return (
        <>
        <Layout message={message} setmessage={setmessage}>
        <form onSubmit={handleSave} id="myform">
        <div className='pd' style={{backgroundColor:'white' ,position:'relative',height:70,paddingTop:10 }}>
            
                <div style={{position:'absolute', left:12}} >
                    {/* <h4><b>{id2 == 0 ? "NEW PO" :  "#" + poCode} [Rev.{rev}]</b></h4> */}
                    <h4><b>MATERIAL</b></h4>
                </div>
                
                <div  style={{position:'absolute', right:12}}>
                <div className='text-right' >
                {type == 0 && (
                        
                        <ConfirmationButton classname='btn btn-success' text="Do you want save this data?" type="submit" title="save" formid="myform" id="btnSubmit" >
                            SAVE
                         </ConfirmationButton>
                      
                 
                      )}     

                    </div>
                    <div className='text-right' style={{display:'none'}}>
                        {type == 0 && (
                    
                     <>
                     <Button
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(evt) => handleClick(evt)}
                         
                      >
                        <MoreVertIcon sx={{ fontSize: 30 }}/>
                      </Button>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={menuOpen}
                        onClose={handleMenuClose}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button',
                        }}
                      >
                        <MenuItem   disabled={id2==0 ? true : false} onClick={() => handleRev('add')} ><AddIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;NEW REVISION</MenuItem>
                        <MenuItem   disabled={id2==0 ? true : (revTemp == rev ? true : false)} onClick={() => handleRev('remove')} ><RemoveIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;CANCEL REVISION</MenuItem>
                        <MenuItem  disabled={id2==0 ? true : false}  onClick={() => handleDefault()} ><CheckCircleIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;SET DEFAULT PO</MenuItem>
                        <MenuItem   disabled={id2==0 ? true : false} onClick={() => handleDelete()} ><LocalPrintshopIcon sx={{ fontSize: 15 }}/>&nbsp;&nbsp;PRINT PO</MenuItem>
                      </Menu>
                       </> 
                    )} 
                    
                        
                     
                  </div>
                </div>
               
        </div>
         <div>
       
           
             <div className='container-fluid' style={{backgroundColor:"white"}} >
             <Box sx={{ p: 2,m:0, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3}}>
                
                    
                  <div className='row'>
                       <div className='col-lg-12'>
                      
                            <div className='row mb-3'>
                                
                                <div className='col-lg-6 p-3'>
                                <span>REQ CODE</span>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Contact Person"
                                      value={contactPerson}
                                      required
                                       onChange={(e) => setContactPerson(e.target.value)}
                                       disabled={true}
                                     
                                    />
                                </div>
                             
                            </div>
                            <div className='row mb-3'>
                               
                                <div className='col-lg-3 p-3'>
                                <span>REG DATE</span>
                                <div>

                                <DatePicker 
                                  showIcon
                                   selected={poDate}
                                   onChange={(date) => {
                                    setPoDate(date); 
                                    //var chooseDate=new Date(date);
                                   // chooseDate.setDate(chooseDate.getDate()+6);
                                    //setValidUntil(chooseDate);
                                }}
                                //disabled={type == 0 ? false : true }
                                
                                  placeholder="PO Date"
                                  fontSize={8}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control"/>
                                </div>
                                
                                </div>
                                <div className='col-lg-3 p-3'>
                                <span>READY DATE</span>
                                <div>
                                <DatePicker 
                                  showIcon
                                   selected={validUntil}
                                  onChange={(date) => setValidUntil(date)}
                                //  disabled={type == 0 ? false : true }
                                   
                                  fontSize={8}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control"/>
                                   </div>
                                </div>
                            </div>

                           
                            
                       </div>
                        
                  </div>
                  <div className='row'>
                  
                        <div className='col-lg-12 p-3 text-right'>
                            <button type='button' className='btn btn-info' onClick={handleClickOpen} >+ ADD ITEM</button>
                        </div>
                  
                  </div>
                  <div className='row mb-6'>
                    <div className='col-lg-12'>
                    <DataGrid  className='fonty' rows={productRows} columns={productColumns}
                    
                     getRowId={(row) => row.product_id}/>
                    </div>
                 </div>
                  
                  </Box>
             </div>
          </div>
  
          </form>
          <CustomDialog title="LIST PRODUCT" subtitle="please select an item from the list below." open={open} setOpen={setOpen} typebutton='none'>
              <DataGrid rows={rows} keepNonExistentRowsSelected  columns={columns}  className='fonty'    
                getRowId={(row) => row.product_id} />
          </CustomDialog>
          {/* <Dialog
             open={open}
             onClose={handleClose}
             maxWidth="md"
             
          >
            <form onSubmit={handleSubmit} role="form"> 
          <DialogTitle>LIST PRODUCT</DialogTitle>
          
        <DialogContent>
          <DialogContentText>
          please select an item from the list below.
          </DialogContentText>
          <div className='row mb-6'>
             <div className='col-lg-12'>
             <DataGrid rows={rows} keepNonExistentRowsSelected  columns={columns}  className='fonty'    
                getRowId={(row) => row.product_id} />
             </div>
           
          </div>
          
        </DialogContent>
        <DialogActions>
          <button className='btn' onClick={handleClose} type='button'>CANCEL</button>
        </DialogActions>
        </form>
      </Dialog> */}
          </Layout>
          </>
    )
}

export default MaterialDetail;